export default __webpack_public_path__ + "static/media/ic_switch_24px.3fde426a.svg";